export function useScrollToInquiryForm() {
  const router = useRouter();
  const route = useRoute();

  const scrollToInquiryForm = () => {
    const section = document.getElementById("inquiry-form");
    if (section) {
      const offset = section.getBoundingClientRect().top + window.scrollY - 48;
      window.scrollTo({ top: offset, behavior: "smooth" });
    } else if (route.path !== "/") {
      router.push("/").then(() => {
        setTimeout(() => {
          const el = document.getElementById("inquiry-form");
          if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 48;
            window.scrollTo({ top, behavior: "smooth" });
          }
        }, 300);
      });
    }
  };

  return { scrollToInquiryForm };
}
